import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import useCurrentPage from '../../../hooks/useCurrentPage';
import { isHomePage } from '../../../../modules/types';
import styles from './styles.scss';

const propTypes = {
  pageType: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  breadcrumbTrail: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

const defaultProps = {
  breadcrumbTrail: [],
};

const slashEmptyPath = path => (path === '' ? '/' : path);

const Breadcrumbs = ({
  name,
  breadcrumbTrail,
  pageType: { code },
}) => {
  if (isHomePage(code)) {
    return null;
  }

  const { breadcrumbsDelineator, primaryFontFamilyClass } = useCurrentPage();

  return (
    <Container className={styles.breadcrumb}>
      <ul>
        {
        breadcrumbTrail.map(
          ({ title: trailTitle, slug: url }) => (
            <li className={primaryFontFamilyClass} key={url}>
              <a href={slashEmptyPath(url)}>{trailTitle}</a> {breadcrumbsDelineator}
            </li>
          ),
        )
      }
        <li>{name}</li>
      </ul>
    </Container>
  );
};

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

export default Breadcrumbs;
